<template>
<div class="layout">
    <h-header 
        :title="title" 
        :back="true"
        :btnIcon="!isShare ? 'iconpingmugongxiang':'icontuichu'"
        :btnText="!isShare ? '选择课件':'退出分享'" 
        @btnFuc="switchShare" 
        @loginSuccess="loginSuccess"
    ></h-header>
   <div class="main-content">
        <div class="class-left">
            <div class="class-video">
                <div id="agora_local" class="video">
                    <video id="video"></video>
                </div>
                <!-- <div id="agora_remote" class="video"></div> -->
            </div>
            <div class="class-chat">
                <div class="chat-head">讨论区</div>
                <div class="chat-scroll">
                    <div class="chat-scroll-content">
                        <div class="chat-lab" v-for="item in chatItem">
                            {{item.message}}
                        </div>
                    </div>
                </div>
                <div class="send-box">
                    <div class="input">
                        <input type="text" v-model="chat" @keyup.enter="sendChat">
                    </div>
                    <div class="send-text" @click="sendChat">发送</div>
                </div>
            </div>
        </div>
        <div class="class-right">
            <div class="back-icon" @click="goBack()">
               <i class="iconfont icontuichu1"></i>
               <span>退出直播</span>
            </div>
        </div>
   </div>
   <div class="share-icon hover" @click="shareLink()">
       <i class="iconfont iconfenxiang"></i>
   </div>
   <share-link v-if="linkShow"
    :url="linkObj.url"
    @closeShareLink="linkShow=false"
   ></share-link>

   <Modal
        v-model="isLoad"
        title="下载安装chrome浏览器"
        @on-ok="ok"
        @on-cancel="cancel">
        <p>屏幕共享功能</p>
        <p>要求Chrome 72 或以上版本，你使用的软件版本不满足此要求，请点击下载安装</p>
    </Modal>
   <h-footer></h-footer>
</div>
</template>
<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
import ShareLink from '../components/ShareLink'
import AgoraRTC from 'agora-rtc-sdk'
import Hls from 'hls.js'
var appID = "f6f2ae7ade1e4090b0d08e3b2cdf9faa"
var videoClient
var screenClient
var videoStream
var screenStream
var remoteStream

var ws 
var tt
var wsUrl = 'wss://api-class.bestmali.cn/ws'
var lockReconnect = false//避免重复连接
var onclass = true
var overMsg

//心跳检测
var heartCheck = {
    timeout: 3000,
    timeoutObj: null,
    serverTimeoutObj: null,
    start: function(that,str){
        var self = this;
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(function(){
            //这里发送一个心跳，后端收到后，返回一个心跳消息，
            if(!onclass) return;
            if(lockReconnect){
                ws.send(str);
            }
            self.serverTimeoutObj = setTimeout(function() {
                ws.close();
                that.reconnectWs();
            }, self.timeout);
        }, this.timeout)
    }
}

export default {
    name:'ClassRoom',
    data(){
        return{
            uid:'',
            nickname:'',
            roomid:'',
            title:'',
            obj:{},
            isShare:false,

            chat:'',
            chatItem:[],

            type : '',

            actionList:[],
            actionNum:0,

            linkShow:false,
            linkObj:{
                url:'',
                secret:''
            },

            isLoad:false
        }
    },
    components:{
        'h-header':Header,
        'h-footer':Footer,
        'share-link':ShareLink
    },
    methods:{
        //登录完成
        loginSuccess(){
            var ua = window.navigator.userAgent
            var tem = ua.match(/(Chrome(?=\/))\/?(\d+)/i)
            if(parseInt(tem[2]) >= 72  && navigator.mediaDevices.getDisplayMedia) {
                // Create the stream for screensharing
                this.obj = this.$route.params.id ? this.$route.params : JSON.parse(localStorage.getItem('ClassRoom'))
                console.log(this.obj)

                // this.logoutClassTime = setTimeout(()=>{
                //     this.goBack()
                // },this.obj.duration*60*1000)

                localStorage.setItem('ClassRoom',JSON.stringify(this.obj))
                this.roomid = this.obj.id + ''
                this.title = this.obj.title
                this.uid = this.$store.state.userData.id
                this.nickname = this.$store.state.userData.nickname

                this.createVideoClient()
                this.createWs()
            }else{
                this.isLoad = true
                console.log('进行安装')
            }   
        },
        switchShare(){
            this.isShare = !this.isShare
            if(this.isShare){
                this.createScreenClient()//进行共享
            }else{
                this.screenLeaveChannel()//离开共享
            }
        },
        createWs(){
            var that = this
            try{
                ws = new WebSocket(wsUrl)
                that.initWs()
            }catch(e){
                that.reconnectWs(wsUrl)
            }
            
            switch (ws.readyState) {
                case WebSocket.CONNECTING:
                    // do something
                    // console.log(1)
                    lockReconnect = true
                    break;
                case WebSocket.OPEN:
                    // do something
                    console.log(2)
                    break;
                case WebSocket.CLOSING:
                    // do something
                    console.log(3)
                    break;
                case WebSocket.CLOSED:
                    // do something
                    console.log(4)
                    break;
                default:
                    // this never happens
                    console.log(5)
                    break;
            }
        },
        initWs(){
            var that = this
            var roomId = that.roomid + ''
            var uid = this.uid
            
            heartCheck.start(that,JSON.stringify({'cmd':'tick','roomid':roomId,'msg':JSON.stringify({uid:uid+''})}))//不放open中是为了防止一开始进来就没有网
            ws.onopen = function () {
                var a = {
                    cmd: 'register',
                    roomid: roomId,
                    msg:JSON.stringify({uid:uid+''})
                }
                ws.send(JSON.stringify(a))
            }
            ws.onmessage = function(event) {
                var data = JSON.parse(event.data)
                // if(data.cmd !== 'tick'){
                //     console.log(data)
                // }
                console.log(data)
                if(data.cmd !== 'unregister'){
                    heartCheck.start(that,JSON.stringify({'cmd':'tick','roomid':roomId,'msg':JSON.stringify({uid:uid+''})}))
                }
                // 处理数据
                switch (data.cmd){
                    case 'register':{
                        if(data.error){
                            that.toast(data.cmd+':'+data.error)
                        }else{
                            lockReconnect = true
                            that.token = data.msg.token
                            // let portrait = data.msg.portrait ? data.msg.portrait : '/avatar/default.png'
                            // that.remoteHead = "background:url("+ that.splitUrl(portrait) +");background-size:100%;"
                            // that.localHead = "background:url("+ that.splitUrl(that.$store.state.userData.portrait) +");background-size:100%;"
                        }
                        break
                    }
                    case 'joinRoom':{
                        let obj = {
                            message:data.msg
                        }
                        that.pushChat(obj)
                        break
                    }
                    case 'chat':{
                        let obj = {
                            type:0,
                            message:data.msg.message
                        }
                        that.pushChat(obj)
                        break
                    }
                    case 'overMsg':{
                        that.toast(data.msg,true,0)
                        overMsg = true
                        break
                    }
                    case 'endClass':{
                        that.goBack()
                        tt && clearTimeout(tt)
                        heartCheck.timeoutObj && clearTimeout(heartCheck.timeoutObj)
                        heartCheck.serverTimeoutObj && clearTimeout(heartCheck.serverTimeoutObj)
                        break
                    }
                }
            }
            ws.onclose = function(){
                lockReconnect = false
                that.reconnectWs()
            }
            ws.onerror = function(event){
                lockReconnect = false
                that.reconnectWs()
            }
        },
        reconnectWs(){
            let that = this
            if(lockReconnect || !onclass) {
                return
            }
            //没连接上会一直重连，设置延迟避免请求过多
            tt && clearTimeout(tt)
            tt = setTimeout(function () {
                that.createWs()
            }, 4000)
        },
        sendChat(){
            let that = this
            if(this.chat == '') return
            let obj = {
                'message':that.nickname+'老师:'+that.chat
            }

            let sendObj = {
                cmd: 'chat',
                token:this.token,
                msg:JSON.stringify({
                    'message':that.nickname+'老师:'+that.chat
                })
            }
            ws.send(JSON.stringify(sendObj))
            this.pushChat(obj)
            this.chat = ''
        },
        pushChat(obj){
            this.chatItem.push(obj)
            setTimeout(()=>{
                this.calScrollChat()
            },200)
            
            // this.clearchat && clearTimeout(this.clearChat)
            // this.clearChat = setTimeout(()=>{
            //     this.chatItem.splice(0,1)
            // },20000)
        },
        createVideoClient(){
            var that = this
            //初始化
            videoClient = AgoraRTC.createClient({mode: 'live', codec: "h264"})
            // 902cfbe4121842f9a731535667393b20
            videoClient.init(appID, function () {
                console.log("AgoraRTC client initialized")
            },function (err) {
                console.log("AgoraRTC client init failed", err)
            })

            //加入频道
            //uid为parseInt,roomid为string
            videoClient.join(null,this.roomid+'',parseInt(this.uid+'1111'), function(uid) {//<TOKEN_OR_KEY>, <CHANNEL_NAME>, <UID>
                console.log("User " + uid + " join channel successfully")
                //发布和订阅音视频流
                /**
                 * streamID：音视频流 ID。设置为用户 ID （uid），可通过 client.join 的回调获取。
                    audio: 是否开启音频。
                    video: 是否开启视频。
                    screen: 是否开启屏幕共享功能。请勿将 video 和 screen 同时设置为 true 。
                */
                videoStream = AgoraRTC.createStream({
                    streamID: uid,
                    audio: true,
                    video: true,
                    screen: false}
                )
                //初始化音频流
                videoStream.init(function() {
                    console.log("getUserMedia successfully")
                    document.getElementById("agora_local").innerHTML = ""
                    setTimeout(()=>{
                        videoStream.play('agora_local')
                    },200)
                    videoClient.publish(videoStream, function (err) {
                        console.log("本地视频发布失败: " + err)
                    })
                    videoClient.on('stream-published', function (evt) {
                        console.log("本地音视频流发布成功")
                    })
                }, function (err) {
                    console.log("getUserMedia failed", err)
                })
            }, function(err) {
                console.log("Join channel failed", err)
            })

            //订阅远端音视频流
            videoClient.on('stream-added', function (evt) {
                var stream = evt.stream;
                console.log("New stream added: " + stream.getId())
                if(stream.getId() == parseInt(this.uid+'0000')){
                    that.isShare = true
                }
                // videoClient.subscribe(stream, function (err) {
                //     console.log("Subscribe stream failed", err)
                // })
                // videoClient.on('stream-subscribed', function (evt) {
                //     console.log('stream-subscribed')
                // })
            })
        },
        createScreenClient(){
            let that = this
            screenClient = AgoraRTC.createClient({mode: 'rtc', codec: "vp8"})
            // 902cfbe4121842f9a731535667393b20
            screenClient.init(appID, function () {
                console.log("AgoraRTC client initialized")
            },function (err) {
                console.log("AgoraRTC client init failed", err)
            })

            //加入频道
            //uid为parseInt,roomid为string
            screenClient.join(null,this.roomid,parseInt(this.uid+'0000'), function(uid) {//<TOKEN_OR_KEY>, <CHANNEL_NAME>, <UID>
                console.log("User " + uid + " join channel successfully")
                //发布和订阅音视频流
                /**
                 * streamID：音视频流 ID。设置为用户 ID （uid），可通过 client.join 的回调获取。
                    audio: 是否开启音频。
                    video: 是否开启视频。
                    screen: 是否开启屏幕共享功能。请勿将 video 和 screen 同时设置为 true 。
                */
                screenStream = AgoraRTC.createStream({
                    streamID: uid,
                    audio: false,
                    video: false,
                    screen: true}
                )
                //初始化音频流
                screenStream.init(function() {
                    // console.log("getUserMedia successfully")
                    // screenStream.play('agora_local')
                    screenClient.publish(screenStream, function (err) {
                        console.log("本地视频发布失败: " + err)
                    })
                    screenClient.on('stream-published', function (evt) {
                        console.log("本地音视频流发布成功")
                    })
                }, function (err) {
                    console.log("getUserMedia failed", err)
                })
            }, function(err) {
                console.log("Join channel failed", err)
            })

            
        },
        leaveChannel(){
            if(!videoClient) return
            videoClient.leave(function () {
                // Stop playing the local stream
                // videoStream.stop()
                // Close the local stream
                videoStream.close()
                // Stop playing the remote streams and remove the views

                videoClient = null
            }, function (err) {
                console.log("channel leave failed");
                console.error(err);
            })
        },
        screenLeaveChannel(){
            if(!screenClient) return
            screenClient.leave(function () {
                // Stop playing the local stream
                // screenStream.stop()
                // Close the local stream
                screenStream.close()
                // Stop playing the remote streams and remove the views
                screenClient = null
            }, function (err) {
                console.log("screen channel leave failed");
                console.error(err);
            })
        },
        goBack(){
            this.$router.go(-1)
        },
        getReplay(){
            let that = this
            that.$post(that,{
                url:'getReplay',
                data:{
                    roomId:that.roomid
                },
                success(data){
                    console.log(data)
                }
            })
        },
        getReplayVideo(){
            let that = this
            that.$post(that,{
                url:'getReplayVideo',
                data:{
                    roomId:that.roomid
                },
                success(data){
                    console.log('getReplayVideo')
                    console.log(data)
                }
            })
        },
        hlsInit(){
            var video = document.getElementById('video')
            if (Hls.isSupported()) {
                var hls = new Hls()
                hls.loadSource('https://best-ecology.oss-cn-hangzhou.aliyuncs.com/classroom/record/109/aae7936afa4bf16fc6b8aa84ef974b04_109.m3u8')
                hls.attachMedia(video)
                hls.on(Hls.Events.MANIFEST_PARSED, function() {
                    video.play()
                })
                hls.on(Hls.Events.ERROR, (event, data) => {
                    console.log(event, data);
                    // 监听出错事件
                    console.log("加载失败")
                })
            }else if(video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = 'https://best-ecology.oss-cn-hangzhou.aliyuncs.com/classroom/record/109/aae7936afa4bf16fc6b8aa84ef974b04_109.m3u8'
                video.addEventListener('loadedmetadata', function() {
                    video.play()
                })
            }
        },
        shareLink(){
            this.linkShow = true
            this.linkObj.url = 'id='+this.obj.id+'&token='+this.obj.token
            this.linkObj.token = this.obj.token
        },
        calScrollChat(){
            let over_content = document.getElementsByClassName('chat-scroll')[0]
            let over_height = over_content.offsetHeight
            let content = document.getElementsByClassName('chat-scroll-content')[0]
            let in_height = content.offsetHeight
            if(in_height > over_height){
                over_content.scrollTop = in_height
            }
        },
        ok(){
            // var ua = window.navigator.userAgent
            // var tem = ua.match(/(Chrome(?=\/))\/?(\d+)/i)
            // console.log(tem)
            window.open('https://www.google.cn/intl/zh-CN/chrome/')
        },
        cancel () {
            
        }
    },
    deactivated(){
        onclass = false
        if(lockReconnect){
            if(overMsg){
                console.log(overMsg)
                var endClass = {
                    cmd:'overClass',
                    roomid:this.roomid,
                }
                ws.send(JSON.stringify(endClass))
            }

            var a = {
                cmd: 'unregister',
                roomid: this.roomid,
            }
            ws.send(JSON.stringify(a))
            ws.close()
        }  

        tt && clearTimeout(tt)
        heartCheck.timeoutObj && clearTimeout(heartCheck.timeoutObj)
        heartCheck.serverTimeoutObj && clearTimeout(heartCheck.serverTimeoutObj)

        // this.logoutClassTime && clearTimeout(this.logoutClassTime)

        this.leaveChannel()
        this.screenLeaveChannel()
    }
}
</script>
<style scoped>
.layout .main-content{
    width:1200px;
    flex:1;
    display: flex;
    margin:10px auto;
    padding-bottom: 40px;
    overflow: hidden;
}
.class-left{
    width:310px;
    margin-right: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.class-video{
    width:100%;
    height: 260px;
    background: #999;
    margin-bottom: 10px;
}
.class-video .video{
    width:100%;
    height: 100%;
}
.class-chat{
    background: #D1D2D6;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.class-chat .chat-head{
    line-height: 27px;
    color:#fff;
    background: #9A9A9C;
    text-align: left;
    font-size: 18px;
    padding-left: 10px;
}
.class-chat .chat-scroll{
    text-align: left;
    padding-left: 10px;
    color:#333333;
    font-size: 16px;
    flex:1;
    overflow-y: auto;
}
.class-chat .send-box{
    height: 40px;
    line-height: 40px;
    display: flex;
}
.class-chat .send-box .input{
    flex:1;
}
.class-chat .send-box .send-text{
    color:#333;
    margin:0 15px;
}
.class-right{
    position:relative;
    flex: 1;
    height: 100%;
    background: #67686D;
}
.class-right .back-icon{
    position:absolute;
    display: inline-block;
    line-height: 15px;
    border-radius: 15px;
    background: #3E4C5E;
    color: #fff;
    font-size: 12px;
    padding:0 12px;
    right:10px;
    top: 10px;
}
.class-right .back-icon .iconfont{
    margin-right: 7px;
}

.share-icon{
    position:fixed;
    width:70px;
    height: 70px;
    line-height: 70px;
    background: #48596F;
    right: 100px;
    bottom: 100px;
    border-radius: 50%;
    color: #fff;
}
.share-icon .iconfont{
    font-size: 35px;
}
video{
    width:100%;
    height: 100%;
}
</style>